import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React, { Component } from "react";
import { Col, Container, FormGroup, Label, Row } from "reactstrap";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { MerchantContact } from "../../models/MerchantModel";
import { SelectItem } from "../../models/SelectItem";
import { PageLayout } from "../../components/ui";
import { merchantContactApiService } from "../../services/api/merchants/MerchantContactsApiService";
import { toastService } from "../../services/toastService";
import { Result } from "../../models/Result";
import ExtendedInputText from "../../components/ExtendedInputText";
import { Check } from "lucide-react";
import StringUtils from "../../utils/stringUtils";

interface AddMerchantContactProps {
    onHide: () => void;
    contact: MerchantContact;
    types: SelectItem[];
    merchantId: number;
    localMode: boolean;
    onSubmit: (contact: MerchantContact) => void;
}

interface AddMerchantContactState {
    contact: MerchantContact;
    isSaving: boolean;
    isSubmit: boolean;
}

export default class AddMerchantContact extends Component<AddMerchantContactProps, AddMerchantContactState> {
    validationErrors: Map<string, boolean> = new Map<string, boolean>();

    constructor(props: AddMerchantContactProps | Readonly<AddMerchantContactProps>) {
        super(props);

        this.state = {
            contact: this.props.contact,
            isSaving: false,
            isSubmit: false,
        };
    }

    updateValue = (fieldName: string, value: string) => {
        const merchantContactDetails: any = this.state.contact;
        merchantContactDetails[fieldName] = value;
        this.setState({ contact: merchantContactDetails });
    };

    onSave = async () => {
        const emptyKeys = Object.keys(this.state.contact).filter((key) => {
            const value = (this.state.contact as any)[key];
            return value === null || value === "";
        });

        if (emptyKeys.length > 0) {
            this.setState({ isSubmit: true });
            return;
        }

        let result: Result<MerchantContact>;
        if (this.props.localMode) {
            result = { success: true, data: null!, message: "" } as Result<MerchantContact>;
        } else {
            result =
                this.state.contact.id == 0
                    ? await merchantContactApiService.create(this.state.contact)
                    : await merchantContactApiService.update(this.state.contact);
        }

        if (result.success) {
            this.setState({ isSaving: false });
            this.props.onSubmit(this.state.contact);
        } else {
            toastService.error(result.message);
        }
    };

    validateInput = (fieldName: string): boolean => {
        const merchantDetails = this.state.contact as any;
        return this.state.isSubmit && (merchantDetails[fieldName] === "" || undefined) ? true : false;
    };

    render() {
        if (this.state.contact == null) {
            return "";
        }
        console.log(this.state.contact.type);
        return (
            <Dialog header="Contact" visible={true} style={{ width: "60vw" }} onHide={this.props.onHide}>
                <PageLayout noTitle>
                    <Container fluid>
                            <Row className="d-flex justify-content-center">
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Contact Name</Label>
                                        <ExtendedInputText
                                            name="Name"
                                            value={this.state.contact.name}
                                            required={this.validateInput("name")}
                                            onChange={(value) => this.updateValue("name", value)}
                                            onValidStatusChanged={(value: boolean) => this.validationErrors.set("name", value)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Contact Phone</Label>
                                        <ExtendedInputText
                                            name="Phone"
                                            value={this.state.contact.phone}
                                            required={this.validateInput("phone")}
                                            onChange={(value) => this.updateValue("phone", value)}
                                            onValidStatusChanged={(value: boolean) => this.validationErrors.set("phone", value)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className="d-flex justify-content-center">
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Contact Email</Label>
                                        <ExtendedInputText
                                            type="email"
                                            value={this.state.contact.email}
                                            onChange={(value) => this.updateValue("email", value)}
                                            validation={() =>
                                                this.state.isSubmit && this.state.contact.email === ""
                                                    ? false
                                                    : this.state.contact.email === ""
                                                      ? true
                                                      : StringUtils.isValidEmail(this.state.contact.email!)
                                            }
                                            name="Email"
                                            onValidStatusChanged={(value: boolean) => this.validationErrors.set("email", value)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup style={{ display: "grid" }}>
                                        <Label>Contact Types</Label>
                                        <Dropdown
                                            value={this.state.contact.type}
                                            options={this.props.types}
                                            onChange={(e) => this.updateValue("type", e.target.value)}
                                            optionLabel="label"
                                            placeholder="Select a Contact Type"
                                            name="type"
                                            className={`${this.state.isSubmit && this.state.contact.type === "" ? "p-invalid" : ""}`}
                                            style={{ width: "100%" }}
                                        />
                                        {this.state.isSubmit && this.state.contact.type === "" && (
                                            <small className="p-error block">Contact Type is required.</small>
                                        )}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="flex justify-end px-5 py-4">
                                <Button label="Submit" icon={<Check size={16} />} loading={this.state.isSaving} onClick={this.onSave} />
                            </div>
                    </Container>
                </PageLayout>
            </Dialog>
        );
    }
}
